// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-light: #e5e7eb;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.plan-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
}

.plan-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

.plan-header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--border-light);
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  margin-right: 1.5rem;
}

.plan-title h2 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.5rem;
  font-weight: 600;
}

.plan-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.5rem;
}
.plan-status.std {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.plan-status.premium {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.plan-status.custom {
  background-color: rgba(147, 51, 234, 0.1);
  color: #9333ea;
}
.plan-status.ent {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.plan-status.int {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}

.plan-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.detail-item .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.detail-item label {
  display: block;
  color: var(--text-light);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.detail-item p {
  margin: 0;
  color: var(--text-dark);
  font-size: 0.95rem;
  font-weight: 500;
}

.role-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.plan-permissions-section {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--border-light);
}
.plan-permissions-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.plan-permissions-section .section-header .section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.plan-permissions-section .section-header .section-title .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
}
.plan-permissions-section .section-header .section-title h3 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.25rem;
  font-weight: 600;
}

.permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}
.permissions-grid .permission-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: white;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  transition: var(--transition);
}
.permissions-grid .permission-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.permissions-grid .permission-item .permission-details {
  flex: 1 1;
}
.permissions-grid .permission-item .permission-details .permission-name {
  font-weight: 600;
  color: var(--text-dark);
  font-size: 0.95rem;
}
.permissions-grid .permission-item .toggle-switch {
  width: 50px;
  height: 24px;
  background-color: #ccc;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: var(--transition);
}
.permissions-grid .permission-item .toggle-switch.enabled {
  background-color: #004A9A;
}
.permissions-grid .permission-item .toggle-switch.disabled {
  background-color: #9ca3af;
}
.permissions-grid .permission-item .toggle-switch .toggle-slider {
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: var(--transition);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.permissions-grid .permission-item .toggle-switch.enabled .toggle-slider {
  transform: translateX(26px);
}
.permissions-grid .permission-item .toggle-switch.disabled .toggle-slider {
  transform: translateX(0);
}

.plan-actions {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--border-light);
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}
.plan-actions .edit-plan-btn,
.plan-actions .back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  border: none;
}
.plan-actions .edit-plan-btn {
  background-color: var(--primary-color);
  color: white;
}
.plan-actions .edit-plan-btn:hover {
  background-color: #3c5ce6;
  transform: translateY(-1px);
}
.plan-actions .back-btn {
  background-color: transparent;
  color: var(--text-medium);
  border: 1px solid var(--border-light);
}
.plan-actions .back-btn:hover {
  background-color: var(--bg-light);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.error-message {
  color: var(--danger-color);
  font-size: 1rem;
  padding: 2rem;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .plan-detail-container {
    padding: 1rem;
  }
  .plan-card {
    padding: 1.5rem;
  }
  .plan-details-grid {
    grid-template-columns: 1fr;
  }
  .permissions-grid {
    grid-template-columns: 1fr;
  }
  .plan-actions {
    flex-direction: column;
  }
  .plan-actions .edit-plan-btn,
  .plan-actions .back-btn {
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .plan-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  .plan-header .avatar {
    margin-right: 0;
  }
  .detail-item .icon {
    margin-top: 0;
  }
  .permission-item {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
    text-align: center;
  }
  .permission-item .permission-icon {
    align-self: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PlanDetailsPage/PlanDetailsPage.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AACF;;AAGA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4CAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAAF;;AAIE;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AADJ;;AAKA;EACE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAIE;EACE,yCAAA;EACA,2BAAA;AAFJ;AAKE;EACE,yCAAA;EACA,2BAAA;AAHJ;AAME;EACE,yCAAA;EACA,cAAA;AAJJ;AAOE;EACE,yCAAA;EACA,2BAAA;AALJ;AAQE;EACE,yCAAA;EACA,2BAAA;AANJ;;AAUA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAPF;AASE;EACE,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AARJ;AAWE;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AATJ;;AAaA;EACE,qBAAA;EACA,wBAAA;EACA,sCAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAVF;;AAcA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AAXF;AAaE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AAXJ;AAaI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAXN;AAaM;EACE,2BAAA;EACA,kBAAA;AAXR;AAcM;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAZR;;AAkBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAfF;AAiBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AAfJ;AAiBI;EACE,yCAAA;AAfN;AAkBI;EACE,SAAA;AAhBN;AAkBM;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;AAhBR;AAoBI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AAlBN;AAoBM;EACE,yBAAA;AAlBR;AAqBM;EACE,yBAAA;AAnBR;AAsBM;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,wCAAA;AApBR;AAuBM;EACE,2BAAA;AArBR;AAwBM;EACE,wBAAA;AAtBR;;AA4BA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AAzBF;AA2BE;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;AAzBJ;AA4BE;EACE,sCAAA;EACA,YAAA;AA1BJ;AA4BI;EACE,yBAAA;EACA,2BAAA;AA1BN;AA8BE;EACE,6BAAA;EACA,yBAAA;EACA,qCAAA;AA5BJ;AA8BI;EACE,iCAAA;AA5BN;;AAiCA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE;IACE,yBAAA;EA9BF;AACF;AAkCA;EACE;IACE,aAAA;EAhCF;EAmCA;IACE,eAAA;EAjCF;EAoCA;IACE,0BAAA;EAlCF;EAqCA;IACE,0BAAA;EAnCF;EAsCA;IACE,sBAAA;EApCF;EAsCE;;IAEE,uBAAA;EApCJ;AACF;AAwCA;EACE;IACE,sBAAA;IACA,kBAAA;IACA,SAAA;EAtCF;EAwCE;IACE,eAAA;EAtCJ;EA2CE;IACE,aAAA;EAzCJ;EA6CA;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;IACA,kBAAA;EA3CF;EA6CE;IACE,kBAAA;EA3CJ;AACF","sourcesContent":[":root {\r\n  --primary-light: #eef2ff;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --warning-color: #f59e0b;\r\n  --text-dark: #1f2937;\r\n  --text-medium: #4b5563;\r\n  --text-light: #9ca3af;\r\n  --bg-light: #f9fafb;\r\n  --card-bg: #ffffff;\r\n  --border-light: #e5e7eb;\r\n  --border-radius: 12px;\r\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n  --transition: all 0.3s ease;\r\n}\r\n\r\n.plan-detail-container {\r\n  padding: 1rem;\r\n  background-color: #f4f6f8;\r\n  display: flex;\r\n  // min-height: 100vh;\r\n}\r\n\r\n.plan-card {\r\n  background-color: var(--card-bg);\r\n  border-radius: var(--border-radius-primary);\r\n  box-shadow: var(--box-shadow);\r\n  width: 100%;\r\n  padding: 2rem;\r\n}\r\n\r\n.plan-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1.5rem;\r\n  border-bottom: 1px solid var(--border-light);\r\n}\r\n\r\n.avatar {\r\n  width: 64px;\r\n  height: 64px;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.75rem;\r\n  font-weight: bold;\r\n  margin-right: 1.5rem;\r\n}\r\n\r\n.plan-title {\r\n  h2 {\r\n    margin: 0;\r\n    color: var(--text-dark);\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.plan-status {\r\n  display: inline-block;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  margin-top: 0.5rem;\r\n\r\n  &.std {\r\n    background-color: rgba(16, 185, 129, 0.1);\r\n    color: var(--success-color);\r\n  }\r\n\r\n  &.premium {\r\n    background-color: rgba(16, 185, 129, 0.1);\r\n    color: var(--success-color);\r\n  }\r\n\r\n  &.custom {\r\n    background-color: rgba(147, 51, 234, 0.1);\r\n    color: #9333ea;\r\n  }\r\n\r\n  &.ent {\r\n    background-color: rgba(16, 185, 129, 0.1);\r\n    color: var(--success-color);\r\n  }\r\n\r\n  &.int {\r\n    background-color: rgba(16, 185, 129, 0.1);\r\n    color: var(--success-color);\r\n  }\r\n}\r\n\r\n.plan-details-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 1.5rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.detail-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n\r\n  .icon {\r\n    color: var(--primary-color);\r\n    font-size: 1.25rem;\r\n    margin-top: 0.25rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  label {\r\n    display: block;\r\n    color: var(--text-light);\r\n    font-size: 0.75rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    color: var(--text-dark);\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.role-badge {\r\n  display: inline-block;\r\n  padding: 0.25rem 0.75rem;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  border-radius: 20px;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n}\r\n\r\n// Plan Permissions Section\r\n.plan-permissions-section {\r\n  margin-top: 2rem;\r\n  padding-top: 2rem;\r\n  border-top: 1px solid var(--border-light);\r\n\r\n  .section-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 1.5rem;\r\n\r\n    .section-title {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.75rem;\r\n\r\n      .icon {\r\n        color: var(--primary-color);\r\n        font-size: 1.25rem;\r\n      }\r\n\r\n      h3 {\r\n        margin: 0;\r\n        color: var(--text-dark);\r\n        font-size: 1.25rem;\r\n        font-weight: 600;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.permissions-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 1rem;\r\n\r\n  .permission-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 1rem;\r\n    background-color: white;\r\n    border: 1px solid var(--border-light);\r\n    border-radius: 8px;\r\n    transition: var(--transition);\r\n\r\n    &:hover {\r\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n    }\r\n\r\n    .permission-details {\r\n      flex: 1;\r\n\r\n      .permission-name {\r\n        font-weight: 600;\r\n        color: var(--text-dark);\r\n        font-size: 0.95rem;\r\n      }\r\n    }\r\n\r\n    .toggle-switch {\r\n      width: 50px;\r\n      height: 24px;\r\n      background-color: #ccc;\r\n      border-radius: 12px;\r\n      position: relative;\r\n      cursor: pointer;\r\n      transition: var(--transition);\r\n\r\n      &.enabled {\r\n        background-color: #004A9A;\r\n      }\r\n\r\n      &.disabled {\r\n        background-color: #9ca3af;\r\n      }\r\n\r\n      .toggle-slider {\r\n        width: 20px;\r\n        height: 20px;\r\n        background-color: white;\r\n        border-radius: 50%;\r\n        position: absolute;\r\n        top: 2px;\r\n        left: 2px;\r\n        transition: var(--transition);\r\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n      }\r\n\r\n      &.enabled .toggle-slider {\r\n        transform: translateX(26px);\r\n      }\r\n\r\n      &.disabled .toggle-slider {\r\n        transform: translateX(0);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.plan-actions {\r\n  margin-top: 2rem;\r\n  padding-top: 2rem;\r\n  border-top: 1px solid var(--border-light);\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: flex-end;\r\n\r\n  .edit-plan-btn,\r\n  .back-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    padding: 0.75rem 1rem;\r\n    border-radius: 8px;\r\n    font-size: 0.9rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: var(--transition);\r\n    border: none;\r\n  }\r\n\r\n  .edit-plan-btn {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n\r\n    &:hover {\r\n      background-color: #3c5ce6;\r\n      transform: translateY(-1px);\r\n    }\r\n  }\r\n\r\n  .back-btn {\r\n    background-color: transparent;\r\n    color: var(--text-medium);\r\n    border: 1px solid var(--border-light);\r\n\r\n    &:hover {\r\n      background-color: var(--bg-light);\r\n    }\r\n  }\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid rgba(67, 97, 238, 0.2);\r\n  border-top-color: var(--primary-color);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin: 0 auto;\r\n}\r\n\r\n.error-message {\r\n  color: var(--danger-color);\r\n  font-size: 1rem;\r\n  padding: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n// Responsive Design\r\n@media (max-width: 768px) {\r\n  .plan-detail-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .plan-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .plan-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .permissions-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .plan-actions {\r\n    flex-direction: column;\r\n\r\n    .edit-plan-btn,\r\n    .back-btn {\r\n      justify-content: center;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .plan-header {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    gap: 1rem;\r\n\r\n    .avatar {\r\n      margin-right: 0;\r\n    }\r\n  }\r\n\r\n  .detail-item {\r\n    .icon {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n\r\n  .permission-item {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: stretch;\r\n    text-align: center;\r\n\r\n    .permission-icon {\r\n      align-self: center;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
